import axios from 'axios';
import { ROOT_URL } from '../globals';

export const FETCH_ACCT_RECIPES_BEGIN   = 'FETCH_ACCT_RECIPES_BEGIN';
export const FETCH_ACCT_RECIPES_SUCCESS = 'FETCH_ACCT_RECIPES_SUCCESS';
export const FETCH_ACCT_RECIPES_FAILURE = 'FETCH_ACCT_RECIPES_FAILURE';
export const RECIPE_SELECTED = 'RECIPE_SELECTED';

export const fetchAcctRecipesBegin = () => ({
  type: FETCH_ACCT_RECIPES_BEGIN
});

export const fetchAcctRecipesSuccess = AcctRecipes => ({
  type: FETCH_ACCT_RECIPES_SUCCESS,
  payload:  AcctRecipes 
});

export const fetchAcctRecipesFailure = error => ({
  type: FETCH_ACCT_RECIPES_FAILURE,
  payload: error
});

export default function fetchAccountRecipes(acctId) {
  return dispatch => {
    const url = `${ROOT_URL}recipes/AccountRecipes/${acctId}`;
    dispatch(fetchAcctRecipesBegin())
    axios.get(url)
      .then (function(result) {
      dispatch(fetchAcctRecipesSuccess(result));
      return result;
    })
    .catch(error => dispatch(fetchAcctRecipesFailure(error)));
  };
}

export const recipeSelected = recipe => ({
  type: RECIPE_SELECTED,
  payload:  recipe 
});



// WEBPACK FOOTER //
// ./src/actions/acct_recipes_actions.js